export default __webpack_public_path__ + "static/media/zombie-bg.c20addf5.jpg";